import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const { t } = useTranslation();
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {t('greeting.title')}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              {greeting.subTitle2 && (
                <p className={isDark ? "dark-mode greeting-subtitle2" : "greeting-subtitle2"}>
                  {t('greeting.subTitle2')}
                </p>
              )}
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {t('greeting.subtitle')}
              </p>
              <div id="resume" className="empty-div"></div>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text={t('greeting.contactMe')} href="#contact" />
                {greeting.resumeLink && (
                  <Button 
                    text={t('greeting.downloadResume')} 
                    href={greeting.resumeLink}
                    download={true}
                    downloadFileName="Ameer_Hamza_Resume.pdf"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/developerActivity.svg")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
